import { render, staticRenderFns } from "./configureView.vue?vue&type=template&id=353c05d8&scoped=true&"
import script from "./configureView.vue?vue&type=script&lang=js&"
export * from "./configureView.vue?vue&type=script&lang=js&"
import style0 from "./configureView.vue?vue&type=style&index=0&id=353c05d8&prod&scoped=true&lang=scss&"
import style1 from "./configureView.vue?vue&type=style&index=1&id=353c05d8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "353c05d8",
  null
  
)

export default component.exports